import classNames from "classnames";

export const QuestionUnit = ({
    indx, 
    questionObj, 
    multArray, 
    ansViewd, 
    optionArr,
    answerArr, 
    answerQuestion 
}) => {

    const handleAnswers = (a,b) => {
        answerQuestion(a,b);
    }

    return (
        <div className="question-unit">
            <div className="q-unit-header">
                <span className="q-num">{indx + 1}</span>
                <span className="q-question">{questionObj.question}</span>
            </div>
            {answerArr.map((answ, k) => (
                <button
                    className={classNames(
                        "answ-unit",
                        {
                            'selected-option': multArray[indx].includes(optionArr[k]),
                            'answered': ansViewd && multArray[indx].includes(optionArr[k])
                        },

                    )}
                    onClick={() => {
                        handleAnswers(indx, optionArr[k]);
                    }}
                    key={k}
                    disabled={ansViewd}
                >
                    <span className={classNames(
                        "ans-indic",
                        {
                            'sel-indic': multArray[indx].includes(optionArr[k]),
                            'corr': ansViewd && multArray[indx].includes(optionArr[k])
                        }
                    )}>
                        {multArray[indx].includes(optionArr[k]) &&
                            (<span className="indic-circ" >i</span>)
                        }
                    </span>
                    <span className="answ-txt">{answ}</span>
                </button>
            ))}
        </div>
    )
}